import React, { useState} from "react";
import { FaBars, FaTimes, FaAddressBook, FaBus } from "react-icons/fa";
import logo from "../../images/logo.png";
import { FaLocationDot } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GrTasks } from "react-icons/gr";
import DateRangeSelector from "./DateRangeSelector";
// import { DateRangePicker } from 'rsuite';
// import { addDays } from 'date-fns';


const Navbar = ({
  sidebarOpen,
  toggleSidebar,
  searchQuery,
  setSearchQuery,
  placeholder,
  showFilter,
  showCalendar,
  selectedDates
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [refreshing, setRefreshing] = useState(false);
  

  const handleNavigation = (path) => {
    if (location.pathname === path && !refreshing) {
      setRefreshing(true);
      navigate(0);
      setTimeout(() => setRefreshing(false), 100);
    } else {
      navigate(path);
    }
  };
  
  return (
    <>
      <nav
        className="flex justify-between bg-gray-100 "
        style={{ paddingRight: "5px", paddingLeft: "5px" }}
      >
        <div className="logo">
          <button className="menu-btn" onClick={toggleSidebar}>
            {sidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
          </button>
          <div style={{ height: "31px" }}>
            <Link to="/" onClick={() => handleNavigation("/")}>
              <img
                src={logo}
                alt="logo"
                style={{
                  width: "120px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            </Link>
          </div>
        </div>
        <div className="flex item-center pt-3 flex-row gap-3">
          {
            showCalendar===true ?<DateRangeSelector selectedDates={selectedDates}/>:null
          }
          {showFilter === true ? (
            <input
              type="text"
              placeholder={placeholder}
              className=""
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          ) : null}
        </div>
      </nav>
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <Link to="/" className="nav_link" onClick={() => handleNavigation("/")}>
          <FaLocationDot />
          <span className="nav_name">Live Track</span>
        </Link>
        <Link
          to="/live-tracking/vehicles"
          className="nav_link"
          onClick={() => handleNavigation("/live-tracking/vehicles")}
        >
          <FaBus />
          <span className="nav_name">Vehicles</span>
        </Link>
        <Link
          to="/live-tracking/address-book"
          className="nav_link"
          onClick={() => handleNavigation("/live-tracking/address-book")}
        >
          <FaAddressBook />
          <span className="nav_name">Address Book</span>
        </Link>
        <Link
          to="/live-tracking/jobs"
          className="nav_link"
          onClick={() => handleNavigation("/live-tracking/jobs")}
        >
          <GrTasks />
          <span className="nav_name">Jobs</span>
        </Link>
        <Link
          to="/live-tracking/punctuality-report"
          className="nav_link"
          onClick={() => handleNavigation("/live-tracking/punctuality-report")}
        >
          <GrTasks />
          <span className="nav_name">Punctuality Report</span>
        </Link>
      </div>
    </>
  );
};

export default Navbar;
